module.exports = __webpack_public_path__ + "img/bg-poster-5.4a2b7b67.webp";